import React from "react";

interface ErrorProps {
  error: string;
}

const Error: React.FC<ErrorProps> = ({ error }) => {
  return (
    <div className="w-3/4 lg:w-1/2 mx-auto fixed inset-0 flex items-center justify-center bg-white">
      <div className="text-center space-y-4">
        <p className="text-xl font-medium text-red-600 leading-relaxed">
          {error}
        </p>
      </div>
    </div>
  );
};

export default Error;